export default "__VITE_ASSET__410cedce__"